// extracted by mini-css-extract-plugin
module.exports = {"segmentStore":"PagePlans_segmentStore__1tJaR","previewContent":"PagePlans_previewContent__1ceE_","cardChip":"PagePlans_cardChip__3SnP0","pageDesc":"PagePlans_pageDesc__3FfjG"};